import { Typography,Box } from "@mui/material";
import { useState,useEffect,Fragment } from "react";
import CoursesBlog from "../../../../Blog/courses-blog.component";
import {getWbcsHistory} from "../../../../../utils/firebase/firebase.utils";
import { Helmet } from "react-helmet-async";

const WbcsHistory = ()=>{

    const [courseData,setCourseData] = useState([]);

    useEffect(()=>{
        const getData = async()=>{
            const arrayData = await getWbcsHistory();
            const{data} = arrayData;
            setCourseData(data.reverse());
        
        }

        getData();
        
        
    },[])




    return(
        <Fragment>
            <Helmet>
                <title>WBCS Study Material History : Prelims and Mains Study Plan for History</title>
                <meta name="description" content="Get daily study material and mock test on History to crack WBCS Prelims and Mains exam . " />        
                <link rel="canonical" href="https://www.ahguide.in/wbcs/study-material-history" />
            </Helmet>
        <Box>
        
            <Typography sx={{textAlign:"center",marginTop:'20px'}} variant="h3" component="div">
                History
            </Typography>
            {
                courseData.map((data)=>{
                    return  <CoursesBlog key={data.title} courseData= {data}  />
                })
            }

        </Box>
        </Fragment>
    )

}

export default WbcsHistory;